import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import ViewUploadFileLogBox from "./ViewUploadFileLog";

export default function SuggestedPaymentUploadBox(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }
    let [viewUploadStatus, setViewUploadStatus] = useState(false);
    const viewUploadFileLog = () => {
        viewUploadStatus = true;
        setViewUploadStatus(viewUploadStatus)
    }


    return (
        <div className="ws-6">
            <Modal open={param.param} onClose={() => returnValue(2)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >

                <div className="ws-12 box">

                    <div className="box">
                        <div className="box-header well">
                            <h2 ><i className="fa fa-sticky-note-o"></i> Suggested Payment Upload</h2>
                        </div>

                        <div className="box-content">
                            <div className="alert alert-warning  ng-hide" data-ng-show="uploadFail">
                                Incorrect file uploaded.  Please check file history.
                            </div>
                            <div className="alert alert-success  ng-hide" data-ng-show="uploadPass">
                                File successfully uploaded.
                            </div>

                            <div className="form-format ws-12">
                                <div className="form-format ws-12">
                                    <label className="control-label ">File Upload</label>
                                    <div className="label-entries ">
                                        <i className="fa fa-file"></i>
                                        <input type="file" className="pull-left  " ngf-select="" ng-model="file" ng-model-rejected="rejFiles" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box-footer">
                            <button className="btn icon-btn edit m0 mr ng-hide" data-ng-show="count &gt; 0" data-ng-click="fileValidation()" title="Validation">
                                <i className="icon-checkmark"></i> Validation
                            </button>
                            <button className="btn icon-btn edit m0 mr ng-hide" data-ng-show="count &gt; 0" data-ng-click="suggestedPaymentClear(1)" title="Clean">
                                <i className="icon-close"></i> Clean
                            </button>
                            <button className="btn icon-btn edit m0 mr ng-hide" ng-hide="showLoad" data-ng-click="validateLoadFile(file)" title="Upload">
                                <i className="icon-floppy"></i> Upload
                            </button>
                            <button className="btn icon-btn edit m0 mr" onClick={() => viewUploadFileLog()} title="File History">
                                <i className="icon-history"></i> File History
                            </button>
                        </div>
                    </div>

                    <div className="box mtl ">
                        <div className="box-header well">
                            <h2 >
                                <i className="fa fa-table"></i> 0 record(s) found
                            </h2>
                        </div>
                        <div className="box-content">

                            <div className="alert alert-info mt " data-ng-show="count &lt; 1">No records to display</div>

                            <div className="control-group ng-hide" data-ng-show="count &gt; 0">
                                <div className="table-responsive">
                                    <table className="table mt">
                                        <thead>
                                            <tr className="list">
                                                <th >Contract Ref Num</th>
                                                <th >Contract Title</th>
                                                <th >Contact</th>
                                                <th >Suggested Payment</th>
                                                <th >Payment</th>
                                                <th >Payment Description</th>
                                                <th >Period</th>
                                                <th >Status</th>
                                                <th >Operations</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="pull-left mt">


                                </div>
                            </div>
                        </div>
                        <div className="box-footer">
                            <button className="icon-btn delete btn-sm  ng-hide" data-ng-click="sugPayFileUploadDialog.close()" ng-hide="true"> Close</button>

                            <button className="btn-pink btn-sm pull-right" ng-click="pageNumber=1; suggestedPaymentCount()" title="Refresh">
                                <i className="icon-reload"></i>
                            </button>
                        </div>
                    </div>

                </div>
            </Modal>
            {
                (() => {
                    if (viewUploadStatus) {
                        return <ViewUploadFileLogBox param={viewUploadStatus} />
                    }
                })()
            }
        </div>
    )
}